import script from "./CommonBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonBackground.vue?vue&type=script&setup=true&lang=ts"

import "./CommonBackground.vue?vue&type=style&index=0&id=589d4731&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589d4731"]])

export default __exports__